import { render, staticRenderFns } from "./NewsCategoryDelete.vue?vue&type=template&id=1a1251f8&"
import script from "./NewsCategoryDelete.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports